import { HTTP } from '@/CallAPI'
export default {
  getChecklistFix (stt) {
    return HTTP.get('checklist-item-fix', {
      params: {stt}
    })
  }
}



// WEBPACK FOOTER //
// ./src/service/dashboard.js